import axios from '@/assets/js/axios.js'
import { v4 as uuidv4 } from 'uuid'
import { LOG_SERVICE_API } from './apis'
function getQueryParams (params) {
  const queryParams = {
    id: uuidv4(),
    timestamp: Date.parse(new Date()),
    version: '1.0',
    params: params,
    empty: false
  }
  return queryParams
}
// 获取产品/设备上下线日志
export function logProductStatusList (params) {
  return axios({
    url: LOG_SERVICE_API.ONLINE_LOG,
    method: 'post',
    data: getQueryParams(params)
  })
}
// 查询设备日志
export function logProductList (params) {
  return axios({
    url: LOG_SERVICE_API.PRODUCT_LOG,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 获取日志详情
export function logDevice (params) {
  return axios({
    url: LOG_SERVICE_API.LOG_DEVICE,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 首页获取设备数量，活跃设备数量
export function deviceCount (params) {
  return axios({
    url: LOG_SERVICE_API.DEVICE_COUNT,
    method: 'post',
    data: params
  })
}
